import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTab4Directive,
	PageTabsLayout,
	PageTabsWidget
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget } from '../../../../ui/widget';
import { AccLoadingPart } from '../acc-loading.part';
import { AcceleratorAreaService } from '../accelerator-area.service';
import { AcceleratorDroplistWidget } from '../accelerator-droplist.widget';
import { AccDeliveryService } from './acc-delivery.service';
import { AccDeliveryAwardsTabPart } from './tabs/awards/acc-delivery-awards-tab.part';
import { AccDeliveryCurriculumTabPart } from './tabs/curriculum/acc-delivery-curriculum-tab.part';
import { AccDeliveryGraduationTabPart } from './tabs/graduation/acc-delivery-graduation-tab.part';
import { AccDeliveryViewsPart } from './views/acc-delivery-views.part';


@Component({
	selector: 'acc-delivery-page',
	standalone: true,
	imports: [
		AcceleratorDroplistWidget,
		AccLoadingPart,
		AccDeliveryCurriculumTabPart,
		AccDeliveryGraduationTabPart,
		AccDeliveryAwardsTabPart,
		AccDeliveryViewsPart,
		PageTab1Directive,
		PageTab2Directive,
		PageTab3Directive,
		PageTab4Directive,
		ToolbarWidget,
		PageTabsWidget,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './acc-delivery.page.html',
})
export class AccDeliveryPage {

	public readonly trimesterWindow = TrimesterWindowEnum.Programming;

	public areaService = inject(AcceleratorAreaService);
	public pageService = inject(AccDeliveryService);

	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}
}